import React from "react";
import { connect } from "react-redux";
import {Grid} from "react-virtualized";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import ErrorIcon from "@mui/icons-material/Error";

import LookListFeature from "../../../lookNavigation/lookMain/lookListFeature/lookListFeature";
import {GROHE_CONFIG} from "../../groheConfig";
import LookWizardSectionListFeature from "../../../lookNavigation/lookMain/lookWizard/lookWizardSectionListFeature";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import LookVirtualizedListLoadingItem
  from "../../../lookNavigation/lookMain/lookCategory/lookVirtualizedListLoadingItem";

const GroheVirtualizedList = (props) => {

  const {lookViewType, windowHeight, renderList, isMobile, onScrollHandler, isWizard, wizardGroup, wizardActiveItem,
    imageCanvas, maxClickCountReached, updateLookCartItem, loadingCount} = props;

  const width = isMobile ? GROHE_CONFIG.sidebarWidth.mobile : GROHE_CONFIG.sidebarWidth.desktop;
  let height = isMobile ? windowHeight - (wizardActiveItem ? 98 : 48) : windowHeight - 120;
  if (loadingCount) {
    height = isMobile ? height + 58 : height + 37;
  }

  const columnWidth = lookViewType === 2 ? width / 3 : width;
  const columnCount = lookViewType === 2 ? 3 : 1;
  const rowCount = Math.ceil((loadingCount || renderList.length) / columnCount);

  const listSettings = {
    width,
    columnCount,
    columnWidth,
    rowCount,
    height,
    rowHeight: lookViewType === 1
      ? 120
      : 124,
    overscanRowCount: 3,
    showScrollingPlaceholder: false,
    useDynamicRowHeight: false,
  }

  const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    if (loadingCount) {
      return <LookVirtualizedListLoadingItem style={style} key={key}/>
    }
    const navItem = renderList[(listSettings.columnCount * rowIndex) + columnIndex];
    if (!navItem) {
      return null
    }
    if (navItem.notInVisSeparator) {
      return (
        <li style={style}
             className="bg-lightgray4 flex"
             key={key}>
          <div className="w-1 h-1 mr-05 bg-white flex rounded-full color-yellow">
            <ErrorIcon/>
          </div>
          <span className="grohe-sold__text bold">
            <FormattedMessage id="grohe.features.productsNotVisualized"/>
          </span>
        </li>
      )
    }
    if (isWizard) {
      return <LookWizardSectionListFeature lookFeature={navItem.part}
                                           wizardGroup={wizardGroup}
                                           imageCanvas={imageCanvas}
                                           maxClickCountReached={maxClickCountReached}
                                           updateLookCartItem={updateLookCartItem}
                                           style={style}
                                           key={key}
                                           navItems={renderList}/>
    }
    return <LookListFeature style={style} lookFeature={navItem.part} key={key} navItems={renderList}/>
  }

  const noRowsRenderer = () => <div className={"ass-list"}>No Features found</div>;

  return (
    <Grid
      // ref="List"
      width={listSettings.width}
      height={listSettings.height}
      onScroll={onScrollHandler}
      overscanRowCount={listSettings.overscanRowCount}
      rowCount={listSettings.rowCount}
      columnCount={listSettings.columnCount}
      columnWidth={listSettings.columnWidth}
      rowHeight={({index}) => {
        if (!loadingCount && renderList && renderList[index] && renderList[index].notInVisSeparator) {
          return 32
        }
        return listSettings.rowHeight
      }}
      cellRenderer={cellRenderer}
      noRowsRenderer={noRowsRenderer}
    />
  )
};

GroheVirtualizedList.propTypes = {
  imageCanvas: PropTypes.object,
  maxClickCountReached: PropTypes.func,
  updateLookCartItem: PropTypes.func,
  renderList: PropTypes.array,
  contentHeight: PropTypes.number,
  isMobile: PropTypes.bool,
  onScrollHandler: PropTypes.func,
  isWizard: PropTypes.bool,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  loadingCount: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {lookViewType} = store.lookState;
  const {windowHeight, isMobile} = store.serverState;
  const {wizardActiveItem} = store.wizardState;
  return {
    lookViewType,
    windowHeight,
    isMobile,
    wizardActiveItem,
  };
};

export default connect(mapStateToProps)(GroheVirtualizedList)
